<template>
  <div class="tw-h-screen tw-w-screen px-body tw-flex tw-flex-col tw-justify-center">
    <h2 class="tw-font-bold font-title tw-text-4xl">
      Signup Successful
    </h2>
    <h3 class="tw-text-xl">
      You have signed up to our platform.
      <br>
      If you have not received an email from us, kindly contact us
    </h3>
    <a class="tw-text-app-blue tw-mt-2 tw-uppercase" href="tel:+254705185570">(+254) 705 185 570</a>
  </div>
</template>

<script>
export default {
  name: 'SignupSuccess',
  data() {
    return {};
  },
};
</script>

<style>

</style>
